export default "/images/logo.png?1cd5e3c2c1859b8f6b3a590556edebad";